<template>

    <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <div class="row d-flex align-items-center  justify-content-center">

                        <div class="col-md-12">
                            <div class="row">
                                <div v-if="userInfo?.contractNumber" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.contractNumber') }}
                                        </b>:
                                        {{ userInfo?.contractNumber }} </p>
                                </div>
                                <div v-if="userInfo?.firstName || userInfo?.lastName" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160"> {{
                                        i18n.t('tables.members.name') }} </b>:
                                        {{ userInfo?.firstName ?? '' }} {{ userInfo?.lastName ?? '' }} </p>
                                </div>
                                <div v-if="userInfo?.email" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.email') }}
                                        </b>:
                                        {{ userInfo?.email }} </p>
                                </div>
                                <div v-if="userInfo?.tele" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.tele') }}
                                        </b>:
                                        {{ userInfo?.tele }} </p>
                                </div>

                                <div v-if="userInfo?.cin" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.cin') }}
                                        </b>:
                                        {{ userInfo?.cin }} </p>
                                </div>
                                <div v-if="userInfo?.adresse" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.adresse') }}
                                        </b>:
                                        {{ userInfo?.adresse }} </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">

                    <div class="row">
                        <div class="col-md-3">

                            <path-image class="img-fiche-member"
                                :path_image="clubInfo?.path_logo ?? `/img/icons/member.png`" />
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div v-if="clubInfo?.name" class="col-md-12 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.club.name') }}
                                        </b>:
                                        {{ clubInfo?.name }} </p>
                                </div>
                                <div v-if="clubInfo?.contractNumber" class="col-md-12 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.club.contractNumber') }}
                                        </b>:
                                        {{ clubInfo?.contractNumber }} </p>
                                </div>
                                <div v-if="clubInfo?.country" class="col-md-12 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.club.country') }}
                                        </b>:
                                        {{ clubInfo?.country }} </p>
                                </div>
                                <div v-if="clubInfo?.city" class="col-md-12 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.club.city') }}
                                        </b>:
                                        {{ clubInfo?.city }} </p>
                                </div>

                                <div v-if="userInfo?.url" class="col-md-12 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.club.url') }}
                                        </b>:
                                        {{ userInfo?.url }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useModal } from '@/composables/modal/useModal';
import { usePDF } from '@/composables/global/usePDF';
import { useGlobal } from "@/composables/global/useGlobal";

import { userPermissions } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";

import { defineProps, toRefs } from 'vue';
const APP_URL = process.env.VUE_APP_URL;
import i18n from "@/i18n/index"
const props = defineProps({
    userInfo: Object,
    clubInfo: Object,
    isBtn: Boolean,
});

let { userInfo, isBtn, clubInfo } = toRefs(props);
const { redirectTo } = useGlobal();

const { openModal } = useModal();

const { ficheInscription } = usePDF();

const { hasPermission } = usePermission();
const userPermissionsList = userPermissions.data;


</script>
